import script from "./GameCenterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GameCenterBar.vue?vue&type=script&setup=true&lang=js"

import "./GameCenterBar.vue?vue&type=style&index=0&id=8081e03c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8081e03c"]])

export default __exports__